export const transformXMLTags = (xmlContent?: string): string => {
  if (!xmlContent) return "";

  const replaceTag = (_match: string, tagType: string, id: string): string =>
    `<CustomTag type='${tagType}' id='${id}' />`;

  // <sc-<tagType> id="<id>" /> matching regex
  // tagType: the type of the tag (e.g. "asset", "model"...)
  const tagRegex = /<sc-(.*) id="([^"]+)"\s*\/>/g;
  return xmlContent.replace(tagRegex, replaceTag);
};
